import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useEffect } from "react";
import "./CountryCodeMenuItem.scss";

const ENABLED_COUNTRY_CODES = ["61", "91", "64"];

const CountryCodeMenuItem = ({
  formik,
  name,
  disabled,
}: {
  formik: any;
  name: string;
  disabled: boolean;
}) => {
  useEffect(() => {
    const detectCountryCode = async () => {
      try {
        if (formik?.values?.[name]) return;

        let detectedCountryCode = "61";

        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
        const locale = navigator.language || "";

        if (
          timeZone.includes("Australia") ||
          locale.toLowerCase().includes("au")
        ) {
          detectedCountryCode = "61";
        } else if (
          timeZone.includes("Auckland") ||
          locale.toLowerCase().includes("nz")
        ) {
          detectedCountryCode = "64";
        } else if (
          timeZone.includes("India") ||
          locale.toLowerCase().includes("in")
        ) {
          detectedCountryCode = "91";
        } else {
          try {
            const res = await fetch("https://ipapi.co/json/");
            const data = await res.json();

            if (data?.country_code === "AU") {
              detectedCountryCode = "61";
            } else if (data?.country_code === "NZ") {
              detectedCountryCode = "64";
            } else if (data?.country_code === "IN") {
              detectedCountryCode = "91";
            }
          } catch (error) {
            console.error("Country auto-detect API failed", error);
          }
        }

        formik.setFieldValue(name, detectedCountryCode);
      } catch (error) {
        console.error("Failed to auto-detect country code", error);
        if (!formik?.values?.[name]) {
          formik.setFieldValue(name, "61");
        }
      }
    };

    detectCountryCode();
  }, [formik, name]);

  return (
    <FormControl variant="outlined" className="country-code">
      <Select
        name={name}
        onChange={formik.handleChange}
        value={formik?.values[name] || "61"}
        displayEmpty
        MenuProps={{
          disablePortal: true,
          classes: {
            paper: "selector-menu-container",
          },
        }}
        renderValue={(selected) => {
          if (!selected) {
            return <span>+61</span>;
          }
          return `+${selected}`;
        }}
        disabled={disabled}
      >
        {menuItem.map((item) => {
          const isEnabled = ENABLED_COUNTRY_CODES.includes(item.value);

          return (
            <MenuItem
              value={item?.value}
              key={item?.id}
              disabled={!isEnabled}
              className={!isEnabled ? "disabled-country-code-option" : ""}
            >
              {`+${item?.value} (${item?.name})`}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default CountryCodeMenuItem;

export const menuItem = [
  { id: "1", value: "61", name: "Australia", countryCode: "AU" },
  { id: "8", value: "91", name: "India", countryCode: "IN" },
  { id: "2", value: "64", name: "New Zealand", countryCode: "NZ" },
  { id: "3", value: "1", name: "United States", countryCode: "US" },
  { id: "4", value: "1", name: "Canada", countryCode: "CA" },
  { id: "5", value: "44", name: "United Kingdom", countryCode: "GB" },
  { id: "6", value: "971", name: "United Arab Emirates", countryCode: "AE" },
  { id: "7", value: "966", name: "Saudi Arabia", countryCode: "SA" },
];
